<template>
    <div @recaptchaResetComponent="reset">

        <div v-if="size !== 'invisible'">
            <div class="small mb-3">
                <a href @click.prevent="reset(0)">
                    <i class="fa fa-refresh fa-fw"></i> Click here to refresh the captcha.
                </a>
            </div>
        </div>

        <div
            id="g-recaptcha"
            class="g-recaptcha"
            :data-sitekey="sitekey"
        ></div>

    </div>
</template>

<script>
export default {
    props: ['sitekey', 'size'],
    data () {
        return {
            widgetId: 0
        }
    },
    methods: {
        execute () {
            window.grecaptcha.execute(this.widgetId)
        },
        reset () {
            window.grecaptcha.reset(this.widgetId)
            // this.$root.$emit('recaptchaReset')
        },
        render () {
            if (window.grecaptcha) {
                this.widgetId = window.grecaptcha.render('g-recaptcha', {
                    sitekey: this.sitekey,
                    size: this.size,
                    // the callback executed when the user solve the recaptcha
                    callback: (response) => {
                        // emit an event called verify with the response as payload
                        this.$root.$emit('recaptchaComplete', response)

                        // reset the recaptcha widget so you can execute it again
                        if (this.size === 'invisible') {
                            this.reset()
                        }
                    }
                })
            }
        }
    },
    mounted () {
        // render the recaptcha widget when the component is mounted
        this.render()

        // Register for the reset
        this.$root.$on('recaptchaReset', (e) => { this.reset(e) })
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Partials/Components/Recaptcha.vue